module.exports = __webpack_public_path__ + "static/media/country_fr.4b813ba0.webp";